import React from "react";

// Mirrors lead_engine.status on the backend exactly (see
// SalesOS-Backend/lead_engine/models/orm.py) - a company row only ever
// moves forward through these 4 in order, one n8n Postgres node per stage.
const STAGES = [
  { key: "new", label: "Found" },
  { key: "contact_found", label: "Contact" },
  { key: "analyzed", label: "Analyzed" },
  { key: "proposal_generated", label: "Proposal" },
];

// Visual pipeline showing which stage a company (or the company an
// in-progress run is currently producing) has reached - done stages filled,
// the current one pulses, the rest stay dim. Used both on the trigger
// form's "in progress" banner and wherever a company's status needs to read
// as more than a bare word (history rows, the detail view).
export function StatusStepper({ status, className = "" }) {
  const currentIndex = Math.max(0, STAGES.findIndex((s) => s.key === status));
  // proposal_generated is the last stage, not just "in progress on the last
  // stage" - once a company reaches it the pipeline is done, so it (and
  // everything before it) should read as done/green, not pulse like it's
  // still running.
  const isComplete = currentIndex === STAGES.length - 1;

  return (
    <div className={`flex items-center ${className}`}>
      {STAGES.map((stage, i) => {
        const state = i < currentIndex || (isComplete && i === currentIndex) ? "done" : i === currentIndex ? "current" : "pending";
        return (
          <React.Fragment key={stage.key}>
            <div className="flex items-center gap-1.5">
              <span
                className={
                  "h-1.5 w-1.5 rounded-full " +
                  (state === "done"
                    ? "bg-emerald-400"
                    : state === "current"
                    ? "bg-blue-400 animate-pulse"
                    : "bg-white/15")
                }
              />
              <span
                className={
                  "text-[11px] font-medium " +
                  (state === "pending" ? "text-gray-500" : state === "current" ? "text-blue-300" : "text-gray-300")
                }
              >
                {stage.label}
              </span>
            </div>
            {i < STAGES.length - 1 && (
              <span className={"mx-2 h-px w-5 " + (i < currentIndex ? "bg-emerald-400/40" : "bg-white/10")} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default StatusStepper;
